/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Icon, View, Text } from '@components/atoms'
import { Fab, FabProps } from '@mui/material'

interface PropsType extends FabProps {
	mode: 'add' | 'edit' | 'cancel' | 'delete' | 'navigate' | 'favorite'
	className?: string
	onClick?: () => void
	disabled?: boolean
}

export const FloatingActionButton = (props: PropsType) => {
	const { mode } = props

	return (
		<View css={style}>
			{mode === 'add' ? (
				<Fab
					className={props.className ?? ''}
					color={props.color ?? 'primary'}
					aria-label="add"
					size={props.size ?? 'medium'}
					variant={props.variant ?? 'circular'}
					onClick={props.onClick}
					disabled={props.disabled ?? false}
				>
					<Icon name="plus" className="fabIcon" />
				</Fab>
			) : mode === 'edit' ? (
				<Fab
					className={props.className ?? ''}
					color={props.color ?? 'primary'}
					aria-label="edit"
					size={props.size ?? 'medium'}
					variant={props.variant ?? 'circular'}
					onClick={props.onClick}
					disabled={props.disabled ?? false}
				>
					<Icon name="pencil" className="fabIcon" />
				</Fab>
			) : mode === 'cancel' ? (
				<Fab
					className={props.className ?? ''}
					color={props.color ?? 'error'}
					aria-label="cancel"
					size={props.size ?? 'medium'}
					variant={props.variant ?? 'circular'}
					onClick={props.onClick}
					disabled={props.disabled ?? false}
				>
					<Icon name="cancel" className="fabIcon" />
				</Fab>
			) : mode === 'delete' ? (
				<Fab
					className={props.className ?? ''}
					color={props.color ?? 'error'}
					aria-label="delete"
					size={props.size ?? 'medium'}
					variant={props.variant ?? 'circular'}
					onClick={props.onClick}
					disabled={props.disabled ?? false}
				>
					<Icon name="trash-can-outline" className="fabIcon" />
				</Fab>
			) : mode === 'navigate' ? (
				<Fab
					className={props.className ?? ''}
					color={props.color ?? 'primary'}
					variant={props.variant ?? 'extended'}
					size={props.size ?? 'medium'}
					onClick={props.onClick}
					disabled={props.disabled ?? false}
				>
					<View className="navigationView">
						<Icon name="navigation" className="fabIcon" />
						<Text className="navigationText" category="s1">
							Navigate
						</Text>
					</View>
				</Fab>
			) : mode === 'favorite' ? (
				<Fab
					className={props.className ?? ''}
					color={props.color ?? 'primary'}
					aria-label="like"
					size={props.size ?? 'medium'}
					variant={props.variant ?? 'circular'}
					onClick={props.onClick}
					disabled={props.disabled ?? false}
				>
					<Icon name="heart" className="fabIcon" />
				</Fab>
			) : null}
		</View>
	)
}

const style = css({
	'.fabIcon': {
		color: 'white',
	},

	'.navigationView': {
		display: 'flex',
		alignItems: 'center',

		'.navigationText': {
			marginLeft: '0.2rem',
		},
	},
})
